var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 201.26 155.91",
    style: {
      enableBackground: "new 0 0 201.26 155.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.95,
    y: 1.62,
    className: "st0",
    fill: "#FECA09",
    width: 198.89,
    height: 119.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#3E3E3F",
    d: "M104.79,77.41h-4.53V64.39c0-2.74-1.21-4.22-3.4-4.39c-1.37-0.11-3.54,0.22-5.11,0.57v16.84h-4.53V57.35 c0,0,5.51-1.23,10.49-1.22c2.15,0,3.87,0.77,5.16,2.06c1.29,1.29,1.93,3.08,1.93,5.39V77.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#3E3E3F",
    d: "M181.21,77.55c-0.74,0.19-1.52,0.28-2.32,0.28c-2.55,0-4.24-0.57-5.06-1.7c-0.66-0.89-0.98-2.59-0.98-5.08 V50.18h4.47v5.9h3.97v3.65h-3.97v11.04c0,1.19,0.15,1.98,0.46,2.36c0.36,0.49,1.12,0.73,2.28,0.73c0.33,0,0.72-0.03,1.16-0.08 V77.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M41.21,63.82c0,0-5.3,2.05-11.85,2.05c-6.54,0-11.85-2.05-11.85-2.05s5.31-2.05,11.85-2.05 C35.91,61.77,41.21,63.82,41.21,63.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M57.6,33.66c0,0-4.7-3.17-8.36-8.48c-3.66-5.32-4.89-10.78-4.89-10.78s4.7,3.17,8.36,8.48 C56.37,28.2,57.6,33.66,57.6,33.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M45.6,46.68c0,0-5.67-0.63-11.44-3.64c-5.78-3.01-9.48-7.26-9.48-7.26s5.67,0.63,11.44,3.64 C41.89,42.42,45.6,46.68,45.6,46.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M57.03,73.7c3.36-0.03,7.42-2.68,7.42-2.68s-9.41-2.85-8.81-11.28c1.85-13.85,13.07-24.72,27.1-26.47 c-1.49-0.21-3.01-0.31-4.56-0.31C60.82,33.04,46.81,46.9,46.89,63.92c0.08,17.02,14.21,30.75,31.57,30.68 c1.45-0.01,2.87-0.12,4.26-0.31c-12.32-1.54-22.34-10.05-25.94-21.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M57.6,93.87c0,0-4.7,3.17-8.36,8.49c-3.66,5.32-4.89,10.78-4.89,10.78s4.7-3.17,8.36-8.49 C56.37,99.33,57.6,93.87,57.6,93.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M45.6,80.85c0,0-5.67,0.63-11.44,3.64c-5.78,3.01-9.48,7.26-9.48,7.26s5.67-0.63,11.44-3.64 C41.89,85.1,45.6,80.85,45.6,80.85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 50.15,
    className: "st1",
    fill: "#3E3E3F",
    width: 4.62,
    height: 27.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#3E3E3F",
    d: "M129.1,59.46c0,2.79-0.86,5.03-2.59,6.72c-1.73,1.69-4.07,2.54-7.02,2.54h-5.6v8.61h-4.62V50.08h9.89 c3.2,0,5.66,0.83,7.37,2.5C128.25,54.25,129.1,56.54,129.1,59.46 M124.43,59.46c0-3.3-1.62-4.95-4.84-4.95h-5.7v9.82h5.61 c1.55,0,2.75-0.43,3.62-1.28C124,62.2,124.43,61,124.43,59.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#3E3E3F",
    d: "M150.49,66.6c0,3.27-0.92,5.91-2.75,7.92c-1.84,2-4.22,3-7.14,3c-2.92,0-5.31-1-7.14-3 c-1.84-2-2.75-4.64-2.75-7.92c0-3.27,0.92-5.91,2.75-7.9c1.83-1.99,4.22-2.98,7.14-2.98c2.95,0,5.34,1,7.16,2.98 C149.58,60.69,150.49,63.32,150.49,66.6 M145.81,66.62c0-2.05-0.48-3.68-1.43-4.88c-0.95-1.2-2.22-1.8-3.79-1.8 c-1.57,0-2.84,0.61-3.79,1.82c-0.95,1.22-1.43,2.83-1.43,4.86c0,2.05,0.48,3.68,1.43,4.88c0.95,1.2,2.22,1.8,3.79,1.8 c1.57,0,2.84-0.6,3.79-1.8C145.33,70.29,145.81,68.67,145.81,66.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#3E3E3F",
    d: "M170.17,70.37c0,2.06-0.8,3.75-2.4,5.08c-1.6,1.33-3.71,1.99-6.33,1.99c-4.09,0-7.25-1.22-9.48-3.65 l3.44-2.88c1.71,1.68,3.71,2.52,6,2.52c1.27,0,2.28-0.25,3.02-0.75c0.74-0.5,1.12-1.13,1.12-1.89c0-0.87-0.43-1.46-1.28-1.79 c-0.5-0.19-1.82-0.45-3.98-0.77c-2.59-0.38-4.44-0.95-5.55-1.7c-1.3-0.92-1.94-2.3-1.94-4.14c0-1.87,0.79-3.43,2.36-4.69 c1.57-1.26,3.67-1.89,6.3-1.89c3.17,0,5.88,1.04,8.12,3.13l-2.69,2.84c-1.63-1.43-3.48-2.15-5.55-2.15 c-2.65,0-3.97,0.75-3.97,2.23c0,0.87,0.61,1.46,1.82,1.79c1.71,0.27,3.41,0.55,5.09,0.85C168.19,65.22,170.17,67.18,170.17,70.37 "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.95,
    y: 121.56,
    className: "st3",
    fill: "#404042",
    width: 198.89,
    height: 33.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    fill: "#FFFFFF",
    points: "72.12,140.1 69.58,142.71 69.58,146.8 66.6,146.8 66.6,130.79 69.58,130.79 69.58,139 77.49,130.79 80.83,130.79 74.11,137.95 81.24,146.8 77.77,146.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M94.23,134.59v12.21h-2.72v-1.56c-0.91,1.12-2.36,1.72-3.93,1.72c-3.13,0-5.26-1.72-5.26-5.4v-6.98h2.86v6.59 c0,2.22,1.05,3.27,2.86,3.27c1.99,0,3.34-1.24,3.34-3.68v-6.18H94.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M104.41,134.45v2.72c-0.25-0.05-0.46-0.07-0.66-0.07c-2.17,0-3.55,1.28-3.55,3.77v5.92h-2.86v-12.21h2.72 v1.78C100.89,135.09,102.37,134.45,104.41,134.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M106.69,130.86c0-0.96,0.78-1.71,1.83-1.71c1.05,0,1.83,0.71,1.83,1.65c0,1-0.75,1.78-1.83,1.78 C107.46,132.57,106.69,131.82,106.69,130.86 M107.07,134.59h2.86v12.21h-2.86V134.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M124.6,141.61h-9.58c0.34,1.78,1.83,2.93,3.96,2.93c1.37,0,2.45-0.43,3.32-1.33l1.53,1.76 c-1.1,1.3-2.81,1.99-4.92,1.99c-4.09,0-6.75-2.63-6.75-6.27c0-3.64,2.68-6.24,6.31-6.24c3.57,0,6.17,2.49,6.17,6.31 C124.64,140.99,124.62,141.33,124.6,141.61 M114.99,139.71h6.93c-0.23-1.76-1.58-2.97-3.45-2.97 C116.61,136.74,115.27,137.93,114.99,139.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#FFFFFF",
    d: "M133.92,134.45v2.72c-0.25-0.05-0.46-0.07-0.66-0.07c-2.17,0-3.55,1.28-3.55,3.77v5.92h-2.86v-12.21h2.72 v1.78C130.39,135.09,131.88,134.45,133.92,134.45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrier);
export default __webpack_public_path__ + "static/media/carrier.de2f5d1a7d6b60dfe1ce49c9bc568c25.svg";
export { ForwardRef as ReactComponent };